
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { rolesStore } from '../store/roles.store';
import { Async } from '@/utils/AsyncDecorators';

@Component({})
export default class UtentiItem extends Vue {
  @Prop()
  item: server.user;

  @Async({ async get() { return await rolesStore.getters.getAll(); }, default: [], lazy: false })
  roles: server.role[];

  get rolesObj() {
    if (this.item.roles && this.item.roles.length <= 0) {
      return {};
    }
    return this.roles.reduce((a, c) => {
      if (!a[c.id]) { a[c.id] = c.name; }
      return a;
    }, {});
  }

  private startX: number = 0;
  private move: number = 0;
  private rowElement: any = null;

  private buttonRowLeftWidth: any = null;
  private buttonRowRightWidth: any = null;

  public async start(e) {
    this.rowElement = this.$refs.rowContent;
    this.buttonRowLeftWidth = (this.$refs.buttonRowSwipeLeft as any)?.offsetWidth ? (this.$refs.buttonRowSwipeLeft as any)?.offsetWidth - 20 : 0;
    this.buttonRowRightWidth = (this.$refs.buttonRowSwipeRight as any)?.offsetWidth ? (this.$refs.buttonRowSwipeRight as any)?.offsetWidth - 20 : 0;
    this.startX = e.touches[0].clientX;
  }

  public onswipe(e) {
    (this.$refs.buttonRowSwipeLeft as any).style = "visibility: visible;";
    (this.$refs.buttonRowSwipeRight as any).style = "visibility: visible;";
    this.move = e.touches[0].clientX - this.startX;
    if (this.move >= 0) {
      
      (this.$refs.buttonRowSwipeRight as any).style = "visibility: hidden";
      // (this.$refs.buttonRowSwipeLeft as any).style = "visibility: visible;";
      if (this.move <= this.buttonRowLeftWidth) {
        this.rowElement.style.transform =
          "translate(" + this.move + "px" + ")";
      } else {
        this.rowElement.style.transform = "translate(" + this.buttonRowLeftWidth + "px)";
      }
    }

    if (this.move < 0) {
      (this.$refs.buttonRowSwipeLeft as any).style = "visibility: hidden;";
      // (this.$refs.buttonRowSwipeRight as any).style = "visibility: visible;";
      if (!(-this.move >= this.buttonRowRightWidth)) {
        this.rowElement.style.transform =
          "translate(" + this.move + "px" + ")";
      } else {
        this.rowElement.style.transform = "translate(-" + this.buttonRowRightWidth + "px)";
      }
    }
  }

  public onstop() {
    if (this.move >= 0) {
      if (this.move < this.buttonRowLeftWidth) {
        this.rowElement.style.transform = "translate(0)";
      }
    }
    if (this.move < 0) {
      if (!(-this.move >= this.buttonRowRightWidth)) {
        this.rowElement.style.transform = "translate(0)";
      }
    }
  }

  public edit(item) {
    this.$emit('edit', item);
  }
}